import React, { useEffect, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchVehicleVehicleStatus,
  initializeVehicleVehicleStatusScreen,
  setDeleteConfirmationPopupVisibility,
  exportVehicleVehicleStatus,
  deleteVehicleVehicleStatus,
  saveVehicleVehicleStatusTableState,
} from "../../../redux/actions/vehicles/vehicleVehicleStatus";
import { FILTER } from "../../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../../utils/date";
import VehicleVehicleStatus from '../../../component/Vehicles/VehicleVehicleStatus';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
function VehicleVehicleStatusScreen(props) {
  const {
    fetchVehicleVehicleStatus,
    initVehicleVehicleStatusScreen,
    showPageLevelLoader,
    vehicleVehicleStatusListview,
    paginationInfo,
    screenPermissions,
    exportVehicleVehicleStatus,
    isVehicleVehicleStatusExportError,
    isVehicleVehicleStatusExportSuccess,
    isLoading,
    deleteVehicleVehicleStatus,
    isVehicleVehicleStatusDeleteSuccess,
    isVehicleVehicleStatusDeleteError,
    shouldOpenDeleteConfirmationPopup,
    setDeleteConfirmationPopupVisibility,
    savedTableState,
    saveVehicleVehicleStatusTableState,
  } = props;
  const navigate = useNavigate();
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    const isISODateString = (str) => typeof str === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    const formatFilterValue = (value) => {
      if (value instanceof Date) return formatDate(value, DATE_STRATEGY.DATE_ISO);
      if (isISODateString(value)) return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      return value;
    };
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(state.filters[key].value),
          });
        }
      });
    }
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined,
    };
  };

  useEffect(() => {
    initVehicleVehicleStatusScreen();
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    if (savedParams) {
      fetchVehicleVehicleStatus(savedParams);
    } else {
      fetchVehicleVehicleStatus({ sortField: 'id' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTableStateChange = (tableState) => {
    saveVehicleVehicleStatusTableState(tableState);
  };

  const loadLazyData = (props) => {
    fetchVehicleVehicleStatus(props);
  };
  const handleCreateVehicleVehicleStatus = () => {
    navigate(APP_URLS.VEHICLE_VEHICLESTATUS.CREATE);
  }
  const editVehicleVehicleStatusRoute = (id) => {
    const path = generatePath(APP_URLS.VEHICLE_VEHICLESTATUS.EDIT, {
      id,
    });
    navigate(path);
  };
  const vehicleVehicleStatus = {
    handleCreateVehicleVehicleStatus,
    exportVehicleVehicleStatus,
    isVehicleVehicleStatusExportError,
    isVehicleVehicleStatusExportSuccess,
    editVehicleVehicleStatusRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    deleteVehicleVehicleStatus,
    isVehicleVehicleStatusDeleteSuccess,
    isVehicleVehicleStatusDeleteError,
    savedTableState,
    onTableStateChange: handleTableStateChange,
    fetchVehicleVehicleStatuss: loadLazyData,
    tableData: {
      columns: vehicleVehicleStatusListview?.columns,
      rows: vehicleVehicleStatusListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <VehicleVehicleStatus
        {...vehicleVehicleStatus}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initVehicleVehicleStatusScreen: () => dispatch(initializeVehicleVehicleStatusScreen()),
    fetchVehicleVehicleStatus: (payload) => dispatch(fetchVehicleVehicleStatus(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportVehicleVehicleStatus: (payload) => dispatch(exportVehicleVehicleStatus(payload)),
    deleteVehicleVehicleStatus: (payload) => dispatch(deleteVehicleVehicleStatus(payload)),
    saveVehicleVehicleStatusTableState: (payload) => dispatch(saveVehicleVehicleStatusTableState(payload)),
  };
};


//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {

    isVehicleVehicleStatusCreateSuccess: selectFromVehicleVehicleStatusReducer(
      state,
      "isVehicleVehicleStatusCreateSuccess"
    ),
    vehicleVehicleStatusListview: selectFromVehicleVehicleStatusReducer(
      state,
      "vehicleVehicleStatusListview"
    ),
    showPageLevelLoader: selectFromVehicleVehicleStatusReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromVehicleVehicleStatusReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromVehicleVehicleStatusReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromVehicleVehicleStatusReducer(
      state,
      "isFetchingGridData"
    ),
    isVehicleVehicleStatusExportError: selectFromVehicleVehicleStatusReducer(
      state,
      "isVehicleVehicleStatusExportError"
    ),
    isVehicleVehicleStatusExportSuccess: selectFromVehicleVehicleStatusReducer(
      state,
      "isVehicleVehicleStatusExportSuccess"
    ),
    shouldOpenDeleteConfirmationPopup: selectFromVehicleVehicleStatusReducer(
      state,
      "shouldOpenDeleteConfirmationPopup"
    ),
    isVehicleVehicleStatusDeleteSuccess: selectFromVehicleVehicleStatusReducer(
      state,
      "isVehicleVehicleStatusDeleteSuccess"
    ),
    isVehicleVehicleStatusDeleteError: selectFromVehicleVehicleStatusReducer(
      state,
      "isVehicleVehicleStatusDeleteError"
    ),
    savedTableState: selectFromVehicleVehicleStatusReducer(
      state,
      "savedTableState"
    ),
    ...ownProps,
  };
};

const selectFromVehicleVehicleStatusReducer = (state, path) => {
  return selectVehicleVehicleStatusReducer(state)[path];
};

const selectVehicleVehicleStatusReducer = ({ vehicleVehicleStatusReducer }) => {
  return vehicleVehicleStatusReducer;
};


export default connect(mapStateToProps, mapDispatchToProps)(VehicleVehicleStatusScreen);
